import React from "react";

export const ExpandIcon = () => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.43634 2.93164H8.85097V4.10237H9.43634H10.0696L7.99932 6.17261L7.5854 6.58653L8.41323 7.41436L8.82715 7.00045L10.8973 4.93026V5.56337V6.14874H12.0681V5.56337V3.51701C12.0681 3.19372 11.806 2.93164 11.4827 2.93164H9.43634ZM3.88265 9.0707V9.65606V10.2891L5.95288 8.21883L6.3668 7.80491L7.19463 8.63274L6.78072 9.04666L4.71032 11.1171H5.34364H5.92901V12.2878H5.34364H3.29728C2.97399 12.2878 2.71191 12.0257 2.71191 11.7024V9.65606V9.0707H3.88265Z"
        fill="white"
      />
      <rect x="0.5" y="0.5" width="14" height="14" stroke="white" />
    </svg>
  );
};
